// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"core":"36623872b6ac3154b1ab","elc-service-vto-common":"50042885c4fc3888a2b1","Vto":"eddf5368ba4780afe44e","VtoSkinCare":"a03d45156816c7ba3035"}[chunkId] + ".bundle.js";
};